import React, { useContext, useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import styles from './MarkdownViewer.module.scss';
import classNames from 'classnames/bind';
import { BASE_URL_IMG } from '~/helper/apiService';
import remarkBreaks from 'remark-breaks';
import { THEMES } from '../MarkdownEditor/MarkdownEditor';
import 'react-syntax-highlighter/dist/esm/styles/prism';
import { ThemeModeContext } from '~/component/Context/ThemeModeProvider';

const cx = classNames.bind(styles);

function MarkdownViewer({ content, theme = 'atomDark' }) {
  const [currentTheme,setCurrentTheme] = useState(theme);
  const {themeMode} = useContext(ThemeModeContext);

  useEffect(() => {
    if (themeMode === "dark") {
      setCurrentTheme('oneDark');
    } else {
      setCurrentTheme('atomDark');
    }
  }, [themeMode]);
  return (
    <div className={cx('wrapper', { [`theme-${currentTheme}`]: currentTheme })}>
      <ReactMarkdown
        children={content}
        remarkPlugins={[remarkGfm, remarkBreaks]}
        components={{
          code({ node, inline, className, children, ...props }) {
            const match = /language-(\w+)/.exec(className || '');
            return !inline && match ? (
              <SyntaxHighlighter style={THEMES[currentTheme]} language={match[1]} PreTag="div" {...props}>
                {String(children).replace(/\n$/, '')}
              </SyntaxHighlighter>
            ) : (
              <code className={className} {...props}>
                {children}
              </code>
            );
          },
          img: ({ node, src, ...props }) => (
            <img {...props} src={BASE_URL_IMG + src} style={{ maxWidth: '100%', borderRadius: '8px' }} alt="Hình ảnh" />
          ),
          a: ({ node, ...props }) => (
            <a {...props} target="_blank" rel="noopener noreferrer">
              {props.children}
            </a>
          ),
        }}
        skipHtml={false}
        remarkRehypeOptions={{ allowDangerousHtml: true }}
      />
    </div>
  );
}

export default MarkdownViewer;
